import React from "react";
import { TextField } from "@mui/material";
import { ARGB_To_RGBA_Color } from "../constants";
import PropTypes from "prop-types"; // added
/*istanbul ignore next */
function TextBox(props) {
  const { item, defaultValue, isRequired, fType } = props;

  const textFieldStyle = {
    position: "absolute",
    top: `${item.SetTop}px`,
    left: `${item.SetLeft}px`,
    borderRadius: 0,
  };

  const { getColor, whenEnable } = getConstants(
    defaultValue,
    fType,
    item,
    isRequired
  );
  if (item.SetTop === 0 && item.SetLeft === 0) {
    return null;
  } else {
    return (
      <TextField
        type="text"
        className="share-text-box-xfdl"
        title={item.ToolTip?.Content || ""}
        name={item.Name}
        value={defaultValue}
        id={item.Name}
        placeholder={item.TextBoxType?.includes("Date") ? "MM/DD/YYYY" : ""}
        onChange={(e) => {
          props.changeHandler(e, item.Name, isRequired);
        }}
        disabled={props.isDisabled}
        variant="outlined"
        InputProps={{
          inputProps: {
            style: getStyle(item, getColor, fType, props, whenEnable),
          },
        }}
        style={textFieldStyle}
      />
    );
  }
}

export default TextBox;

TextBox.propTypes = {
  fType: PropTypes.string,
  defaultValue: PropTypes.string,
  isRequired: PropTypes.bool,
  item: PropTypes.shape({
    ToolTip: PropTypes.shape({
      Content: PropTypes.string,
    }),
    Name: PropTypes.string.isRequired,
    SetTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    SetLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    Width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Foreground: PropTypes.string,
    FontFamily: PropTypes.string,
    FontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FontStyle: PropTypes.string,
    FontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    TextAlignment: PropTypes.string,
    TextBoxType: PropTypes.string,
    TextDecorations: PropTypes.string,
  }).isRequired,
  changeHandler: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

TextBox.defaultProps = {
  fType: "",
  defaultValue: "",
  isRequired: false,
  isDisabled: false,
};

function getStyle(item, getColor, fType, props, whenEnable) {
  return {
    padding: "0 0px",
    fontFamily: item.FontFamily ? item.FontFamily : "Arial",
    fontSize: 14,
    fontStyle: item.FontStyle,
    fontWeight: item.FontWeight ? item.FontWeight : 600,
    color: getColor,
    textAlign: item.TextAlignment,
    width: `${item.Width}px`,
    height: fType === "NonAcord" ? item.Height : Math.min(item.Height, 20),
    backgroundColor: "white",
    borderRadius: 0,
    border: props.isDisabled ? "None" : whenEnable,
  };
}

function getConstants(defaultValue, fType, item, isRequired) {
  const whenNotReq = defaultValue ? "1px solid black" : "2px solid blue";
  const checkNonAcordColor =
    fType === "NonAcord"
      ? ARGB_To_RGBA_Color(item.Foreground)
      : item.Foreground;
  const getColor = item.Foreground ? checkNonAcordColor : "black";
  const whenEnable = isRequired ? "2px solid red" : whenNotReq;
  return { getColor, whenEnable };
}
